export enum ProductName {
  GOLD = 'Pakiet Gold',
  SILVER = 'Pakiet Silver',
  BASIC = 'Pakiet Basic',
  PLATINIUM = 'Pakiet Platinium',
  DIAMOND = 'Pakiet Diamond',
  SAVEDATE = 'Save The Date',
  QRINSTRUCTION = '10 instrukcji z kodem QR',
  GUESTTASKS = '40 karty zadań dla gości',
  QRCARDS = '100 wizytówek z kodem QR',
  NFCSTICKER = 'Naklejka Potwierdzenie NFC - 20szt.',
  QRPLATE = 'Tabliczka z kodem QR',
}

export enum IProductState {
  UNKNOW = 'unknow',
  NEW = 'new',
  MODIFIABLE = 'modifable',
  CREATED = 'created',
  ACTIVE = 'active',
  EXPIRED = 'expired',
}
